import React, { useState, useEffect, useRef } from "react";
// import { Tabs, Tab, Accordion } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Tabs, Tab, Typography, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import "./financialStatement.css";
import { Navbar } from "../../Components/Navbar";
import BalanceSheet from "../../Components/BalanceSheet/BalanceSheet";
import PNLStatement from "../../Components/pnlStatement/PNLStatement";
import Notes from "../../Components/Notes/Notes";
import DynamicNotes from "../../Components/Notes/DynamicNotes";
import PnlNotes from "../../Components/PnlNotes/PnlNotes";
import CreateInput from "../../Components/createInput/CreateInput";
import arrowLeftGreen from "../../assets/arrowLeftGreen.svg";
import Disclosures from "../../Components/Disclosures/Disclosures";
import CashFlow from "../../Components/CashFlow/CashFlow";
import GeneralNote from "../../Components/GeneralNotes/GeneralNote";
import DisclosuresChecklist from "../../Components/DisclosuresChecklist/DisclosuresChecklist";
import { GetProject } from "../../WorkSpace/Components/ApiServices/apiHandler";
import DynamicPnlNotes from "../../Components/Notes/DynamicPnlNotes"
// import StyleExport from "../../Components/excelExport/styleExport";
import PrimaryButton from "../../Components/Common/PrimaryButton";
import UpdatedSocie from "../../Components/socie/UpdatedSocie";
import NoteSoftDelete from "../../Components/templateTabs/NoteSoftDelete/softDelete";
import RestoreSoftDelete from "../../Components/templateTabs/NoteSoftDelete/restoreSoftDelete";


import Sidebar from "../../myfin_v2/elements/Sidebar";
import workSpaceCss from "../../myfin_v2/css/workSpaceOverView.module.css"
import FSSideMenu from "../../myfin_v2/components/fs/FSSideMenu";
import FSTopBar from "../../myfin_v2/components/fs/FSTopBar";

// import { ReactComponent as DeleteIcon} from "../../myfin_v2/assets/icons/delete_icon_primary.svg";
import Modal from "../../../src/myfin_v2/elements/Modal";
import modalcss from "../../../src/myfin_v2/css/modal.module.css";
import { ReactComponent as DeleteIconWhite } from "../../myfin_v2/assets/icons/delete.svg";
import { ReactComponent as CloseIcon } from "../../myfin_v2/assets/icons/close.svg";
// import  { useState, useEffect, useContext } from "react"; 
import buttoncss from "../../myfin_v2/css/button.module.css";
import { Button } from "../../myfin_v2/elements/Button";
import { set } from "react-hook-form";
import swal from "sweetalert";
import { softDeleteNotesData } from "../../services/api/apiHandler";
import { socket } from "../../services/socket/socket";

import { motion } from "framer-motion";
import commoncss from "../../myfin_v2/css/common.module.css"
import bookclosurecss from "../../myfin_v2/css/bookclosure.module.css"
import { clearSoftDeleteNotes } from "../../redux/actions/TemplateTabs/actionDN";


const main = {
  // padding: "2rem 4rem",
  backgroundColor: "rgb(229, 229, 229)",
  minHeight: "calc(100vh - 80px)",
  minWidth: "1045px",
  marginTop: "2.4rem",
  overflowX: "hidden",
};

const header = {
  height: "80px",
  width: "100%",
  backgroundColor: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: 'space-between',
  padding: "0rem 1rem",
  borderRadius: "3px",
  marginBottom: "2rem",


};


const leftheader = {
  display: 'flex',
  alignItems: 'center',
  gap: '30px'
}

const line = {
  height: "50px",
  width: "2px",
  border: "1px solid rgb(229, 229, 229)",
};

const name = {
  fontSize: "15px",
  fontWeight: "500",
  paddingLeft: "1%",
  paddingRight: "2%",
};

const mainTag = {
  fontSize: "1.15rem",
  fontWeight: "700",
};

const backNav = {
  fontSize: "1.2rem",
  fontWeight: "600",
  color: "#03565A",
  cursor: "pointer",
};

// for material ui tab function
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div

      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
// end tab function

const FinancialStatement = () => {
  const project_id = localStorage.getItem("project_id");
  const user = JSON.parse(localStorage.getItem('user'));
  const history = useHistory();
  const dispatch = useDispatch();
  const financialStatementTabs = ["Balance Sheets", "P&L Statement", "CashFlow", "SOCIE", "General Notes", "Balance Sheet Notes", "PNL Statement Notes", "Disclosures", "Disclosures Checklist"];
  const presetNoteKey = useSelector((initialState) => initialState.HandlePopulateFsNotesReducer.noteKey);
  const softDeletedData = useSelector((state) => state.NotesSoftDelete.selectedNotes)
  const [key, setKey] = useState("Balance Sheets");
  const [note, setNote] = useState(0);
  const [showCreateInput, setShowCreateInput] = useState(false);
  const [sid, setSid] = useState(null);
  const [nid, setNid] = useState(null);
  const [NoteNumber, setNoteNumber] = useState(1); // the one with the addition logic
  const [notenum, setNoteNum] = useState(1); //
  const [noteName, setNoteName] = useState(""); //
  const [notenum2, setNoteNum2] = useState(1);
  const [rows, setRows] = useState([]);
  const [str, setStr] = useState("");
  const [render, setRender] = useState("");
  const [precision, setPrecision] = useState("Units");
  const [floatdata, setFloat] = useState();
  const [note4, setNote4] = useState(null);
  const [currentProfit, setCurrentProfit] = useState("");
  const [currentYearProfit, setCurrentYearProfit] = useState("");
  const [comProfit, setComProfit] = useState("");
  const [comYearProfit, setComYearProfit] = useState("");
  const [projectData, setProjectData] = useState({});
  const [allProject, setAllProject] = useState([]);
  const [headerdata, setDataHeader] = useState("");
  const [ShowInDecimals, setShowInDecimals] = useState(false)

  const [deleteItemsModel, setDeleteItemsModal] = useState(false);
  const tb_id = localStorage.getItem("tb_id");


  const menuItems = [
    { label: "Balance Sheet", value: "Balance Sheets" },
    { label: "P&L Statement", value: "P&L Statement" },
    { label: "CashFlow", value: "CashFlow" },
    { label: "SOCIE", value: "SOCIE" },
    { label: "General Notes", value: "General Notes" },
    { label: "Balance Sheet Notes", value: "Balance Sheet Notes" },
    { label: "PNL Statement Notes", value: "PNL Statement Notes" },
    { label: "Disclosures", value: "Disclosures" },
    { label: "Disclosures Checklist", value: "Disclosures Checklist" },
  ];

  const [fromScoie, setFromScoie] = useState({
    SAMoney_pending_allotment_cy: 0,
    SAMoney_pending_allotment_py: 0,
    otherEquity_cy: 0,
    otherEquity_py: 0,
  });

  const units = [
    { value: "Units", label: "Units" },
    // { value: 'Tens', label: 'Tens' },
    { value: "Hundreds", label: "Hundreds" },
    { value: "Thousands", label: "Thousands" },
    { value: "Lakhs", label: "Lakhs" },
    { value: "Crores", label: "Crores" },
  ];

  const decimal = [
    { value: "0", label: "0" },
    { value: "1", label: "1" },
    { value: "2", label: "2" },
    { value: "3", label: "3" },
    { value: "4", label: "4" },
  ];

  useEffect(() => {
    let isMounted = true;
    const checkMounted = () => isMounted;

    if (noteName == 1) {
      console.log("one clicked da");
      window.scrollTo({
        bottom: 0,
        behavior: "smooth",
      });
      return () => {
        isMounted = false;
      };
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    const auth = localStorage.getItem("auth_token");
    let headers = {
      "x-auth-token": auth,
    };

    fetchProject(headers, checkMounted);
    AllProject(checkMounted);

    return () => {
      isMounted = false;
    };
  }, [noteName]);

  const fetchProject = (headers, checkMounted) => {
    axios
      .get(`/api/v1/project/get-project-details/${project_id}`, { headers })
      .then((response) => {
        if (!checkMounted || checkMounted()) {
          setProjectData(response.data.project);
        }
        console.log(response.data, "11111111");
      })
      .catch((error) => {
        console.log(error.response, "here error");
      });
  };


  const handleSoftDelete = () => {
    const payload = {
      "selectedNotes": softDeletedData
    }

    softDeleteNotesData(project_id, payload).then(() => {
      socket.emit("request-mapped-grouping", { project_id, tb_id });
      socket.emit("request-balance-sheet", { project_id, tb_id })
      socket.emit("request-pnl-statement", { project_id, tb_id });
      socket.emit("request-fetch-console-notes", { pid: project_id });
      dispatch(clearSoftDeleteNotes());
    }).catch((err) => {
      swal("Error!", err.message, "error", {
        button: "OK",
      });
    })
  }
  const handleDelete = () => {

    handleSoftDelete();
    swal("Poof! Selected Notes has been deleted!", {
      icon: "success",
    });
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleHeader = (e) => {
    saveHeader(e.target.value);
  };

  const saveHeader = (val) => {
    const auth = localStorage.getItem("auth_token");
    const project_id = localStorage.getItem("project_id");
    let headers = {
      "x-auth-token": auth,
    };
    let data = {
      header_name: val,
    };
    axios
      .post(`/api/v1/pnl/save-header/${project_id}`, data, { headers })
      .then((response) => {
        console.log(response.data, "KKK");
        // setRows(response.data.balance_sheet);
      })
      .catch((error) => {
        console.log(error.response, "error");
      });
  };
  const brackets = (val) => {
    // const summa = 'Hundreds'
    // const summa = 'Thousands' 
    // const summa = 'Lakhs'
    const summa = precision;
    const float_value = floatdata;
    const k = [
      { value: 1, label: "Units", suffix: "" },
      // { value: 10 , label: 'Tens',suffix:''},
      { value: 100, label: "Hundreds", suffix: "" },
      { value: 1000, label: "Thousands", suffix: "" },
      { value: 100000, label: "Lakhs", suffix: "" },
      { value: 10000000, label: "Crores", suffix: "" },
    ];

    const object = k.find((e) => e.label === summa);
    const total = parseFloat(val / object.value).toFixed(float_value);

    if (val < 0) {
      const negNum = -1 * total;
      console.log(object, "object hered object");

      return "(" + negNum.toLocaleString("en-IN") + `${object.suffix}` + ")";
    }
    return total.toLocaleString("en-IN") + `${object.suffix}`;
  };
  const AllProject = async (checkMounted) => {
    const res = await GetProject();
    if (res.status === 200) {
      if (!checkMounted || checkMounted()) {
        console.log(res.data, "00000");
        setAllProject(res.data.project);
      }
    }
  };
  const workspaceBack = () => {
    const project_id = localStorage.getItem("project_id");
    const nameOfType = allProject.filter((adj) => adj._id === project_id);
    const result = nameOfType[0]?.workspace_id
      ? nameOfType[0]?.workspace_id
      : "";
    history.push(`/financialstatement/${result}`);
  }

  const [notes, setNotes] = useState([]);
  const [activeTab, setActiveTab] = useState(0);

  const [disclosuresList, setDisclosuresList] = useState([]);
  const [disclosuresTab, setDisclosuresTab] = useState(0);



  const handleTabs = (idx) => {
    setActiveTab(idx);
  }

  const addNotesChildRef = useRef();

  const handleAddNotesClick = () => {
    if (addNotesChildRef.current) {
      addNotesChildRef.current.AddNewNote();  // ✅ calling child’s function
    }
  };

  const deletedGNNotesChildRef = useRef();

  const handleDeletedGNNotesClick = () => {
    console.log("handleDeletedGNNotesClick");

    if (deletedGNNotesChildRef.current) {
      deletedGNNotesChildRef.current.GetSoftDeletedGN();
    }
  };

  const [activeTabPNL, setActiveTabPNL] = useState(0);
  const [activeTabDisclosureCheckList, setActiveTabDisclosureCheckList] = useState(0);
  const handleTabsDisclosureCheckList = (idx) => {
    dispatch({ type: "NOTE_INDEX", payload: idx });
    setActiveTabDisclosureCheckList(idx);
  }
  const handleTabsPNL = (idx) => {
    setActiveTabPNL(idx);
  }





  const [PnlSubMenus, setPnlSubMenus] = useState([]);
  const [DisclosuresChecklistSubMenu, setDisclosuresChecklistSubMenu] = useState([]);

  const [bsNotes, setBSNotes] = useState([]);

  const [bsActiveTab, setBSActiveTab] = useState(0);

  const addDiscNotesChildRef = useRef();

  const handleAddDiscNotesClick = () => {
    if (addDiscNotesChildRef.current) {
      addDiscNotesChildRef.current.addNote();  // ✅ calling child’s function
    }
  };
  const tabManagement = (i) => {
    switch (i) {
      case 0:
        return <div style={{ minHeight: "100%", }}><BalanceSheet
          scrollToTop={scrollToTop}
          projectData={projectData}
          fromScoie={fromScoie}
        />
        </div>
      case 1:
        return <div style={{ minHeight: "100%", }}> <PNLStatement
          precision={precision}
          NoteNumber={NoteNumber}
          notenum2={notenum2}
          setKey={setKey}
          scrollToTop={scrollToTop}
          rows={rows}
          setCurrentProfit={setCurrentProfit}
          setCurrentYearProfit={setCurrentYearProfit}
          setComYearProfit={setComYearProfit}
          currentProfit={currentProfit}
          setNote={setNote}
          setComProfit={setComProfit}
          projectData={projectData}
          floatdata={floatdata}
        /></div>
      case 2:
        return <div style={{ maxHeight: "100%", }}> <CashFlow /> </div>
      case 3:
        return <UpdatedSocie />
      // <div style={{ height: "55vh", overflowX:"scroll", }}> 
      // <Socie
      //   currentProfit={currentProfit}
      //   comProfit={comProfit}
      //   currentYearProfit={currentYearProfit}
      //   comYearProfit={comYearProfit}
      //   projectData={projectData}
      //   setFromScoie={setFromScoie}
      //   fromScoie={fromScoie}
      // />
      // </div>
      case 4:
        return <div style={{ maxHeight: "100%", }}> <GeneralNote setNotes={setNotes} activeTab={activeTab}
          ref={addNotesChildRef} del_ref={deletedGNNotesChildRef} /> </div>
      case 5:
        return <div style={{ minHeight: "100%", }}>{projectData.company_type === 'NBFC' ?
          <DynamicNotes
            note={note}
            setShowCreateInput={setShowCreateInput}
            setNoteName={setNoteName}
            setStr={setStr}
            setNid={setNid}
            setSid={setSid}
            setNoteNum={setNoteNum}
            brackets={brackets}
            render={render}
            setBSNotes={setBSNotes}

            bsActiveTab={bsActiveTab}

          /> :
          <Notes
            note={note}
            setShowCreateInput={setShowCreateInput}
            setNoteName={setNoteName}
            setStr={setStr}
            setNid={setNid}
            setSid={setSid}
            setNoteNum={setNoteNum}
            brackets={brackets}
            render={render}
            projectData={projectData}
          />}</div>
      case 6:
        return <div style={{ minHeight: "100%", }}>{projectData.company_type === 'NBFC' ?
          <DynamicPnlNotes
            note={note}
            setShowCreateInput={setShowCreateInput}
            setNoteName={setNoteName}
            setStr={setStr}
            setNid={setNid}
            setSid={setSid}
            setNoteNum={setNoteNum}
            brackets={brackets}
            setPnlSubMenus={setPnlSubMenus}
            // activeTab={activeTab}
            activeTabPNL={activeTabPNL}
            ref={addDiscNotesChildRef}
          />
          :
          <PnlNotes
            note={note}
            setShowCreateInput={setShowCreateInput}
            setNid={setNid}
            setSid={setSid}
            setNoteNum={setNoteNum}
            projectData={projectData}
          />}</div>
      case 7:
        return <div style={{ maxHeight: "100%", }}> <Disclosures
          scrollToTop={scrollToTop}
          setKey={setKey}
          setNoteName={setNoteName}
          setDisclosuresList={setDisclosuresList}
          disclosuresTab={disclosuresTab}
          ref={addDiscNotesChildRef}
        /> </div>
      case 8:
        return <div style={{ maxHeight: "100%", }}> <DisclosuresChecklist
          setDisclosuresChecklistSubMenu={setDisclosuresChecklistSubMenu}
          activeTabDisclosureCheckList={activeTabDisclosureCheckList}

        /> </div>
      default:
        return <></>;
    }
  }
  return (
    <>
      <div className={`${workSpaceCss.df}`} >
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 100, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
          >

            <FSSideMenu title="Financial Statements" menuItems={menuItems} activeItem={presetNoteKey} notes={notes} setActiveTab={setActiveTab} setActiveTabPNL={setActiveTabPNL} handleTabsPNL={handleTabsPNL} handleTabs={handleTabs} handleAddNotesClick={handleAddNotesClick} PnlSubMenus={PnlSubMenus} DisclosuresChecklistSubMenu={DisclosuresChecklistSubMenu}
              setActiveTabDisclosureCheckList={setActiveTabDisclosureCheckList} handleTabsDisclosureCheckList={handleTabsDisclosureCheckList} bsNotes={bsNotes}
              setBSActiveTab={setBSActiveTab}
              disclosuresList={disclosuresList}
              setDisclosuresTab={setDisclosuresTab}
              handleAddDiscNotesClick={handleAddDiscNotesClick} />
          </motion.div>
          <div className={bookclosurecss.bookClosureContent}>
            <div className={`${bookclosurecss.bookClosureHeader} p-0`}>
              <FSTopBar setShowInDecimals={setShowInDecimals} ShowInDecimals={ShowInDecimals} history={history} softDeletedData={softDeletedData} deleteItemsModel={deleteItemsModel} setDeleteItemsModal={setDeleteItemsModal} activeItem={presetNoteKey} handleDeletedGNNotesClick={handleDeletedGNNotesClick} />
            </div>
            <div style={{ "height": "88vh", "overflow": "auto" }}>
              {financialStatementTabs.map((label, index) => (
                <CustomTabPanel value={presetNoteKey} index={index}>
                  {tabManagement(index)}
                </CustomTabPanel>
              ))
              }
            </div>
          </div>
        </div>

      </div>

      {deleteItemsModel && (<Modal
        headerActions={
          <CloseIcon
            onClick={() => {
              // handleClose();
              setDeleteItemsModal(false);
            }}
            className="clickable"
          />
        }
        headerBottomLine={false}
        onClose={() => console.log("Modal Closed")}
      >
        <span className={`${modalcss.modalBodyHead} mb-1`}>
          Do you want to <span className="fw700">delete </span>
          selected items?
        </span>
        <span
          className={`${modalcss.modalBodycnt}`}
          style={{ "margin-bottom": "35px" }}
        >
          Once deleted, you can restore using the bin
        </span>
        <span
          className={`${modalcss.modalBodycnt} ${modalcss.modalBodyBtns}`}
        >
          <Button
            btnColor={buttoncss.danger}
            label="Delete"
            icon={<DeleteIconWhite width={20} height={20} />}
            onClick={() => {
              // deleteCompany();
              //  handleSoftDelete();
              handleDelete();
              setDeleteItemsModal(false);
            }}
          />
          <Button
            btnColor={buttoncss.secondary_del}
            label="Cancel"
            onClick={() => {
              // handleClose();
              setDeleteItemsModal(false);
            }}
          />
        </span>
      </Modal>
      )}
    </>
  );
};

export default FinancialStatement;